export default __webpack_public_path__ + "static/media/Edenred-EMP-banner-payment-limits.6bb0fc50.jpg";